import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "AID_BASIC",
  title: defineMessage({
    id: "fig.finance.aid.AID_BASIC.title",
    defaultMessage: ``,
  }),
  caption: defineMessage({
    id: "fig.finance.aid.AID_BASIC.caption",
    defaultMessage: ``,
  }),
  source: defineMessage({
    id: "fig.finance.aid.AID_BASIC.source",
    defaultMessage: ``,
  }),
};
